import React, { useState } from "react";
import "./Searchbar.css";
import { Redirect } from "react-router";
import Loadspinner from "../../Loadspinner";
import * as images from "../../../constants/Images";
import SearchMenu from "../SearchComponent";
import CommonConstants from "../../../constants/CommonConstants";

function Searchbar() {
  const [searchWord, setWord] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [searchbyKeyword, setSearchbyKeyword] = useState(false);
  const [searchbyData, setsearchbyData] = useState(false);
  const [searchData, setsearchData] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const handleWord = (e) => {
    setWord(e.target.value);
    setLoading(false);
  };
  const openModal = (val) => {
    setShowModal(val);
  };
  const setMasterSearchData = (data) => {
    setsearchData(data);
    setsearchbyData(true);
    setSearchbyKeyword(false);
  };

  const getInfoBySearch = () => {
    if (searchWord == "") {
      setSearchbyKeyword(false);
    } else {
      setSearchbyKeyword(true);
    }
  };

  const onKeyUp = (e) => {
    if (e?.key?.toLowerCase() == "enter") {
      getInfoBySearch();
    }
  }

  if ((searchbyKeyword && searchWord != "") || searchbyData) {
    return (
      <Redirect
        to={{
          pathname: "/search",
          state: {
            searchWord: searchWord,
            searchData: searchData,
            isKeyword: searchbyKeyword,
          },
        }}
      />
    );
  }

  return (
    <div className="search-bar">
      <Loadspinner filename="Searchbar.js" isLoading={isLoading} />
      <div className="input-group">
        <button
          className="btn search-menu-btn"
          type="button"
          onClick={() => openModal(true)}
        >
          <img src={images.search_menu} className="search-icons" />
        </button>
        {showModal ? (
          <SearchMenu
            handleModal={openModal}
            setSearchData={setMasterSearchData}
          />
        ) : null}
        <input
          type="text"
          className="form-control search-input"
          placeholder="Search"
          onChange={handleWord}
          onKeyUp={(e) => onKeyUp(e)}
          autoComplete={CommonConstants.autoCompleteInput}
        />
        <button
          className="btn search-btn"
          type="button"
          onClick={getInfoBySearch}
        >
          <img src={images.search} className="search-icons" />
        </button>
      </div>
    </div>
  );
}

export default Searchbar;
